import { render, staticRenderFns } from "./IndividualTeamYJDetail.vue?vue&type=template&id=58174b21&scoped=true"
import script from "./IndividualTeamYJDetail.vue?vue&type=script&lang=js"
export * from "./IndividualTeamYJDetail.vue?vue&type=script&lang=js"
import style0 from "./IndividualTeamYJDetail.vue?vue&type=style&index=0&id=58174b21&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./IndividualTeamYJDetail.vue?vue&type=style&index=1&id=58174b21&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58174b21",
  null
  
)

export default component.exports